import * as React from 'react';

import {stripTypename} from 'nutshell-core/utils/strip-typename';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {Body} from 'shells/typography/body';

import type {LicenseType} from 'nutshell-graphql-types';

import {LicenseSwitch} from './license-switch';

type Props = {
    isLoading: boolean;
    licenseOverview: any;
    handleSwitchToggle: (licenseType: LicenseType) => void;
    getIsOnStateForLicenseType: (licenseType: LicenseType) => boolean;
};

export function LicenseSwitchList(props: Props) {
    if (props.isLoading) {
        return <LoadingPage />;
    }
    const licenseKeys =
        props.licenseOverview && Object.keys(stripTypename(props.licenseOverview.instanceLicenses));
    const isEmptyState = licenseKeys.length === 0;

    return (
        <StackLegacy spacing={24}>
            {isEmptyState ? (
                <Body isItalic={true}>No licenses found</Body>
            ) : (
                // @ts-expect-error
                licenseKeys.map((key) => {
                    const licenseInfo = props.licenseOverview.instanceLicenses[key];
                    const licenseType = licenseInfo.licenseType;

                    return (
                        <LicenseSwitch
                            key={key}
                            isHorizontal={true}
                            licenseType={licenseType}
                            licenseInfo={licenseInfo}
                            handleSwitchToggle={props.handleSwitchToggle}
                            // @ts-expect-error
                            toastState='initial'
                            isOn={props.getIsOnStateForLicenseType(licenseType)}
                        />
                    );
                })
            )}
        </StackLegacy>
    );
}
